/*
 * @Author: caiqin.xie
 * @since: 2023-10-12 15:25:52
 * @lastTime: 2023-10-12 15:25:52
 * @LastEditors: caiqin.xie
 * @message: 首页
 */

// 首页banner 文字 和 按钮 默认位置
export const bannerPositon = {
  pc: {
    titleLeft: 11,
    titleTop: 19,
    btnLeft: 11,
    btnTop: 70
  },
  pad: {
    titleLeft: 11,
    titleTop: 19,
    btnLeft: 50,
    btnTop: 60
  },
  mobile: {
    titleLeft: 10,
    titleTop: 25,
    btnLeft: 50,
    btnTop: 60
  }
}